import { StickyFooter } from '../../../../../components/Toolkit/StickyFooter/StickyFooter';

import styled from 'styled-components';

import { media } from '../../../../../helpers/breakpoints';

// TODO: use sticky footer from toolkit V2
export const MobileAndTabletStickyFooter = styled(StickyFooter)`
  z-index: ${({ theme }) => theme.zIndices.STICKY_BUTTON};

  ${media.large} {
    display: none;
  }
`;
